export enum PricingModel {
    /**
     * Used for teams that are used solely for testing or demoing purposes. Nothing
     * will ever be charged for these teams.
     *
     * Added 2022-04
     */
    Test = 'Test',

    /**
     * Old pricing model based on unlocking results to access the full potential
     */
    UnlockResults = 'UnlockResults',

    /**
     * Enterprise solution where the customer pays a fixed amount to a consultant (prifloat) and
     * the consultant will pay of unlocking the results.
     *
     * The system will behave as a subscription, so we will not have any results unlocked events,
     * instead this will be handled manually by checking survey closed events or some other type
     * of reporting done monthly.
     *
     * Added 2022-01
     */
    UnlockResultsNoPrice = 'UnlockResultsNoPrice',

    /**
     * Teams and projects subscribe to PQi
     *
     * Added 2022-01
     */
    Subscription = 'Subscription',
}
